/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Tooltip } from 'antd';
import { useMapContext } from '../context/map-context';
import capitalize from '../../../../utils/capitalize';
import { AssetIcon } from '../../../lib/asset-icon/AssetIcon';

export const AssetDetails = (): JSX.Element | null => {
  const { selectedPin, onCloseAssetDetails, selectedPinIconUrl } = useMapContext();

  if (!selectedPin) return null;

  interface IItemProps {
    title: string;
    value: string | number;
  }

  const DetailsItem:React.FC<IItemProps> = ({ title, value }) => (
    <div style={{
      display: 'flex',
      flexDirection: 'row',
      borderBottom: '1px solid rgba(0, 0, 0, 0.10)',
      width: '100%',
      fontSize: '14px',
      fontWeight: 400,
      padding: '12px 5px',
    }}
    >
      <span style={{ color: '#616161', width: '100px' }}>
        {capitalize(title)}
        :
      </span>
      <Tooltip title={value}>
        <span style={{
          color: '#292121',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        >
          {value}
        </span>
      </Tooltip>

    </div>
  );

  return (
    <div style={{
      width: '365px',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'white',
    }}
    >
      <div style={{
        display: 'flex', flexDirection: 'column', gap: '16px', padding: '24px',
      }}
      >
        <div style={{
          display: 'flex', flexDirection: 'row', gap: '10px', padding: '4px 0',
        }}
        >
          <div
            onClick={() => onCloseAssetDetails()}
            style={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >

            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.8334 10H4.16675" stroke="#232426" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M10.0001 15.8334L4.16675 10L10.0001 4.16669" stroke="#232426" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>

          <span style={{ fontSize: '18px', color: '#292121' }}>
            Asset details
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <AssetIcon src={selectedPinIconUrl} size={72} />
        </div>
        <div style={{
          width: '100%', height: '1px', backgroundColor: 'rgba(0, 0, 0, 0.10)',
        }}
        />
      </div>
      <div style={{
        width: '100%', height: '100%', overflow: 'scroll', display: 'flex', flexDirection: 'column', padding: '0px 16px 16px 16px',
      }}
      >
        {Object.entries(selectedPin).map(([title, value]) => {
          if (title === 'uniqueKey') return null;
          return (
            <DetailsItem
              key={title + value}
              title={title}
              value={value}
            />
          );
        })}
      </div>

    </div>
  );
};
